import {
  getLanguage,
  getLoginPath,
  getRegistrationPath,
} from '../selectors/configSelectors';
import { put, select, call, delay } from 'redux-saga/effects';
import { myAxaFetchWithToken } from '../../../utils/myAxaFetchWithToken';
import {
  STORE_HEALTH_KEEPER_TOKEN,
  CLEAR_HEALTH_KEEPER_TOKEN,
} from '../actions/healthKeeperAction';
import {
  getCachedHealthKeeperTokenExpireTime,
  getCachedHealthKeeperToken,
} from '../selectors/healthKeeperSelector';
import moment from 'moment';
import {
  getCustomer,
  getCustomerIsCwp,
} from '../../../selectors/userSelectors';
import uuidv4 from 'uuid/v4';

export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_API_ERROR = 'CREATE_USER_API_ERROR';

export const AUTHENTICATION_USER_API_ERROR = 'AUTHENTICATION_USER_API_ERROR';
export const AUTHENTICATION_USER_EXIST = 'AUTHENTICATION_USER_EXIST';
export const AUTHENTICATION_USER_NOT_EXIST = 'AUTHENTICATION_USER_NOT_EXIST';

export const GET_HEALTH_KEEPER_TOKEN_SUCCESS =
  'GET_HEALTH_KEEPER_TOKEN_SUCCESS';
export const GET_HEALTH_KEEPER_TOKEN_SUCCESS_CACHE =
  'GET_HEALTH_KEEPER_TOKEN_SUCCESS_CACHE';
export const GET_HEALTH_KEEPER_TOKEN_NEW_USER =
  'GET_HEALTH_KEEPER_TOKEN_NEW_USER';
export const GET_HEALTH_KEEPER_TOKEN_FAIL = 'GET_HEALTH_KEEPER_TOKEN_FAIL';

/**
 * Remarks
 * localhost calling on Health Keeper is only available with CORs chrome extension.
 * https://chrome.google.com/webstore/detail/allow-cors-access-control/lhobafahddgcelffkeicbaginigeejlf
 */

export function* postHealthKeeperCreateAccountAPI(): any {
  try {
    const locale = yield select(getLanguage);
    const registrationPath = yield select(getRegistrationPath);
    const isCWP = yield select(getCustomerIsCwp);
    let customer = yield select(getCustomer);
    while (!customer) {
      yield delay(1000);
      customer = yield select(getCustomer);
      if (!customer && isCWP) {
        customer = { englishName: 'Visitor' };
      }
    }
    const response = yield call(
      myAxaFetchWithToken,
      registrationPath,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-axahk-msgid': uuidv4(),
        },
        body: JSON.stringify({
          userRegistrationRequest: {
            name: customer.englishName,
            locale: locale === 'en' ? 'en_HK' : 'zh_HK',
          },
        }),
      },
      undefined,
      undefined,
      0,
    );
    if (response.status === 200) {
      const responseJson = yield response.json();
      yield put({ type: STORE_HEALTH_KEEPER_TOKEN, payload: responseJson });
      return {
        type: CREATE_USER_SUCCESS,
        payload: responseJson,
        status: response.status,
        url: registrationPath,
      };
    } else {
      return {
        type: CREATE_USER_API_ERROR,
        status: response.status,
        url: registrationPath,
      };
    }
  } catch (err) {
    return {
      type: CREATE_USER_API_ERROR,
      status: err.status || 501,
      url: '',
    };
  }
}

export function* fetchHealthKeeperAuthenticateAPI(): any {
  try {
    const authenticatePath = yield select(getLoginPath);
    const authenticateResponse = yield call(
      myAxaFetchWithToken,
      authenticatePath,
      {
        method: 'POST',
        headers: {
          'x-axahk-msgid': uuidv4(),
          'Content-Type': '',
        },
      },
      undefined,
      undefined,
      0,
    );

    if (authenticateResponse.status === 200) {
      const authenticateJson = yield authenticateResponse.json();
      if (authenticateJson.enabled) {
        yield put({
          type: STORE_HEALTH_KEEPER_TOKEN,
          payload: authenticateJson,
        });
        return {
          type: AUTHENTICATION_USER_EXIST,
          payload: authenticateJson,
          status: authenticateResponse.status,
          url: authenticatePath,
        };
      } else {
        yield put({ type: CLEAR_HEALTH_KEEPER_TOKEN });
        return {
          type: AUTHENTICATION_USER_NOT_EXIST,
          status: authenticateResponse.status,
          url: authenticatePath,
        };
      }
    } else if (authenticateResponse.status === 404) {
      yield put({ type: CLEAR_HEALTH_KEEPER_TOKEN });
      return {
        type: AUTHENTICATION_USER_NOT_EXIST,
        status: authenticateResponse.status,
        url: authenticatePath,
      };
    } else {
      yield put({ type: CLEAR_HEALTH_KEEPER_TOKEN });
      return {
        type: AUTHENTICATION_USER_API_ERROR,
        status: authenticateResponse.status,
        url: authenticatePath,
      };
    }
  } catch (err) {
    if (err.status == 404) {
      yield put({ type: CLEAR_HEALTH_KEEPER_TOKEN });
      return {
        type: AUTHENTICATION_USER_NOT_EXIST,
        status: err.status,
        url: '',
      };
    } else {
      yield put({ type: CLEAR_HEALTH_KEEPER_TOKEN });
      return {
        type: AUTHENTICATION_USER_API_ERROR,
        status: err.status || 501,
        url: '',
      };
    }
  }
}

export function* getHealthKeeperToken(action: any): any {
  const expireTime = yield select(getCachedHealthKeeperTokenExpireTime);
  const cachedToken = yield select(getCachedHealthKeeperToken);
  if (action && action.isForceRefresh) {
    // skip cache
  } else if (expireTime && cachedToken) {
    const currentTime = moment().format('x');
    if (currentTime < expireTime) {
      return {
        type: GET_HEALTH_KEEPER_TOKEN_SUCCESS_CACHE,
        payload: {},
        token: cachedToken,
      };
    }
  }
  try {
    const authenticateResult = yield fetchHealthKeeperAuthenticateAPI();
    if (authenticateResult.type == AUTHENTICATION_USER_EXIST) {
      return {
        type: GET_HEALTH_KEEPER_TOKEN_SUCCESS,
        payload: authenticateResult,
        token: authenticateResult.payload.access_token,
      };
    } else if (authenticateResult.type == AUTHENTICATION_USER_NOT_EXIST) {
      return {
        type: GET_HEALTH_KEEPER_TOKEN_NEW_USER,
        payload: authenticateResult,
      };
    } else if (authenticateResult.type == AUTHENTICATION_USER_API_ERROR) {
      return {
        type: GET_HEALTH_KEEPER_TOKEN_FAIL,
        payload: authenticateResult,
      };
    }
    return {
      type: GET_HEALTH_KEEPER_TOKEN_FAIL,
    };
  } catch (error) {
    return {
      type: GET_HEALTH_KEEPER_TOKEN_FAIL,
    };
  }
}
